import { all, call, put, takeLatest } from "redux-saga/effects";
import { getErrorMessageString } from "utils/utils";
import apiService from "services/apiservice";
import { loadState } from "library/helpers/sessionStorage";
import {
  GET_CUSTOMERS_REQUEST,
  GET_CUSTOMER_LINEITEMS_LOOKUP_REQUEST,
  GET_CUSTOMER_ADDRESSES_REQUEST,
  ADD_UPDATE_CUSTOMER_LINE_ITEM_REQUEST,
  ADD_UPDATE_CUSTOMER_ADDRESS_REQUEST,
  ADD_UPDATE_CUSTOMER_DETAILS_REQUEST,
} from "./actionTypes";
import {
  getCustomersSuccess,
  getCustomersFailure,
  getCustomerLineItemsLookupSuccess,
  getCustomerLineItemsLookupFailure,
  getCustomerAddressesSuccess,
  getCustomerAddressesFailure,
  addUpdateCustomerLineItemSuccess,
  addUpdateCustomerLineItemFailure,
  addUpdateCustomerAddressSuccess,
  addUpdateCustomerAddressFailure,
  addUpdateCustomerDetailsSuccess,
  addUpdateCustomerDetailsFailure,
} from "./actions";
import { Customer, CustomerAddress, CustomerLineItem } from "./types";

const currentUser = loadState("loggedInUser");
const token = currentUser?.accessToken;

const getRequest = async (url: string) => {
  const { data } = await apiService.get(url, {
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
  return data;
};

const postRequest = async (url: string, payload: any) => {
  const { data } = await apiService.post(url, payload, {
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
  return data;
};

function* getCustomersSaga(action: any) {
  try {
    const response: Customer[] = yield call(postRequest, action.url, {});
    yield put(getCustomersSuccess(response));
  } catch (e: any) {
    const errorMessages = getErrorMessageString(e);
    yield put(getCustomersFailure(errorMessages));
  }
}

function* getCustomerLineItemsLookupSaga(action: any) {
  try {
    const response: CustomerLineItem[] = yield call(getRequest, action.url);
    yield put(
      getCustomerLineItemsLookupSuccess(action.customerId, response ?? []),
    );
  } catch (e: any) {
    const errorMessages = getErrorMessageString(e);
    yield put(getCustomerLineItemsLookupFailure(errorMessages));
  }
}

function* getCustomerAddressesSaga(action: any) {
  try {
    const response: CustomerAddress[] = yield call(getRequest, action.url);
    yield put(getCustomerAddressesSuccess(action.customerId, response ?? []));
  } catch (e: any) {
    const errorMessages = getErrorMessageString(e);
    yield put(getCustomerAddressesFailure(errorMessages));
  }
}

function* addUpdateCustomerLineItemSaga(action: any) {
  try {
    const response: { status: boolean; message: string } = yield call(
      postRequest,
      action.url,
      action.payload,
    );
    yield put(addUpdateCustomerLineItemSuccess(response?.message));
    action.callback("Success", response?.message);
  } catch (e: any) {
    const errorMessages = getErrorMessageString(e);
    yield put(addUpdateCustomerLineItemFailure(errorMessages));
    action.callback("Error", errorMessages);
  }
}

function* addUpdateCustomerAddressSaga(action: any) {
  try {
    const response: { status: boolean; message: string } = yield call(
      postRequest,
      action.url,
      action.payload,
    );
    yield put(addUpdateCustomerAddressSuccess(response?.message));
    action.callback("Success", response?.message);
  } catch (e: any) {
    const errorMessages = getErrorMessageString(e);
    yield put(addUpdateCustomerAddressFailure(errorMessages));
    action.callback("Error", errorMessages);
  }
}

function* addUpdateCustomerDetailsSaga(action: any) {
  try {
    const response: { status: boolean; message: string } = yield call(
      postRequest,
      action.url,
      action.payload,
    );
    yield put(addUpdateCustomerDetailsSuccess(response?.message));
    action.callback("Success", response?.message);
  } catch (e: any) {
    const errorMessages = getErrorMessageString(e);
    yield put(addUpdateCustomerDetailsFailure(errorMessages));
    action.callback("Error", errorMessages);
  }
}

export function* settingsSaga() {
  yield all([
    takeLatest(GET_CUSTOMERS_REQUEST, getCustomersSaga),
    takeLatest(
      GET_CUSTOMER_LINEITEMS_LOOKUP_REQUEST,
      getCustomerLineItemsLookupSaga,
    ),
    takeLatest(GET_CUSTOMER_ADDRESSES_REQUEST, getCustomerAddressesSaga),
    takeLatest(
      ADD_UPDATE_CUSTOMER_LINE_ITEM_REQUEST,
      addUpdateCustomerLineItemSaga,
    ),
    takeLatest(
      ADD_UPDATE_CUSTOMER_ADDRESS_REQUEST,
      addUpdateCustomerAddressSaga,
    ),
    takeLatest(
      ADD_UPDATE_CUSTOMER_DETAILS_REQUEST,
      addUpdateCustomerDetailsSaga,
    ),
  ]);
}
